<template>
  <div class="safedig-associations">
    <h1 class="safedig-page-title">{{ $t('community.title') }}</h1>

    <ul class="safedig-association-list">
      <li v-for="(item, index) in associations" :key="index" class="safedig-association-item">
        <a :href="item.url" target="_blank" rel="noopener noreferrer" class="safedig-association-link">
          <span class="safedig-association-title">{{ $t(item.titleKey) }}</span>
          <span class="safedig-association-url">{{ item.url }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SafeDigCommunity',
  data() {
    return {
      associations: [
        { titleKey: 'community.associations.holidaySchedule', url: 'https://indiana811.org/resources/holiday-schedule' },
        { titleKey: 'community.associations.indiana811', url: 'https://indiana811.org/' },
        { titleKey: 'community.associations.damagePreventionCouncils', url: 'https://indiana811.org/damage-prevention-councils/' },
        { titleKey: 'community.associations.damageToUnderground', url: 'https://www.in.gov/iurc/2640.htm' },
        { titleKey: 'community.associations.inpaa', url: 'https://www.inpaa.org/' },
        { titleKey: 'community.associations.iurc', url: 'http://www.in.gov/IURC' },
        { titleKey: 'community.associations.cga', url: 'http://commongroundalliance.com/' },
        { titleKey: 'community.associations.uppa', url: 'http://www.in.gov/iurc/2847.htm' }
      ]
    };
  }
};
</script>

<style scoped>
.safedig-associations {
  max-width: 800px;
}

.safedig-page-title {
  font-size: 34px;
  font-weight: 700;
  color: #1e3a5f;
  margin: 26px 0 13px;
  line-height: 1.3;
}

.safedig-association-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.safedig-association-item {
  margin: 0;
}

.safedig-association-link {
  display: block;
  text-decoration: none;
  color: inherit;
  border: 1px solid #e5e7eb;
  border-radius: 2px;
  overflow: hidden;
  transition: opacity 0.15s;
}

.safedig-association-link:hover {
  opacity: 0.9;
}

.safedig-association-title {
  display: block;
  padding: 0.75rem 1rem;
  background: #d4e8f0;
  color: #1e3a5f;
  font-size: 1rem;
  font-weight: 600;
}

.safedig-association-url {
  display: block;
  padding: 0.5rem 1rem;
  background: #fff;
  color: #1f2937;
  font-size: 0.9rem;
  word-break: break-all;
}
</style>
